export const normalizeLocale = (locale: string) => {
  const map: { [key: string]: string } = {
    en: 'en-US',
    es: 'es-ES',
    fr: 'fr-FR',
    de: 'de-DE',
    it: 'it-IT',
    nl: 'nl-NL',
    sv: 'sv-SE',
    zh: 'zh-CN',
    ja: 'ja-JP',
  };
  return map[locale] || locale;
};

export const localeDateFormats = (locale: string) => {
  const formats: { [key: string]: string } = {
    'en-US': 'MMM D, YYYY',
    'es-ES': 'D MMM YYYY',
    'fr-FR': 'D MMM YYYY',
    'de-DE': 'D MMM YYYY',
    'it-IT': 'D MMM YYYY',
    'nl-NL': 'D MMM YYYY',
    'sv-SE': 'MMM D YYYY',
    'zh-CN': 'YYYY MMM D',
    'zh-TW': 'YYYY MMM D',
    'ja-JP': 'YYYY MMM D',
  };
  const normalized = normalizeLocale(locale);
  return formats[normalized] || formats['en-US'];
};

export const localeDateMonthFormat = (locale: string) => {
  const formats: { [key: string]: string } = {
    'en-US': 'MMM D',
    'es-ES': 'D MMM',
    'fr-FR': 'D MMM',
    'de-DE': 'D MMM',
    'it-IT': 'D MMM',
    'nl-NL': 'D MMM',
    'sv-SE': 'MMM D',
    'zh-CN': 'MMM D',
    'zh-TW': 'MMM D',
    'ja-JP': 'MMM D',
  };
  const normalized = normalizeLocale(locale);
  return formats[normalized] || formats['en-US'];
};
